(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    class AddToCartTotalPrice {
    constructor() {
      this.init();
    }

    init() {
      // Listen for quantity selector updates
      document.addEventListener('quantitySelectorUpdate', this.updateTotalPrice.bind(this));
      // Also listen for variant updates to update base price
      document.addEventListener('variantUpdate', this.updateBasePrice.bind(this));
      // Initialize on page load
      this.updateAllTotalPrices();
    }

    updateTotalPrice(event) {
      const quantity = event.detail.quantity;
      this.updateAllTotalPrices(quantity);
    }

    updateBasePrice(event) {
      // Update base price when variant changes
      const newVariant = event.detail.data.variant;
      if (newVariant && newVariant.price) {
        const totalPriceDisplays = document.querySelectorAll('.total-price-display');
        totalPriceDisplays.forEach(display => {
          display.dataset.basePrice = newVariant.price;
        });
        this.updateAllTotalPrices();
      }
    }

    updateAllTotalPrices(quantity = null) {
      const totalPriceDisplays = document.querySelectorAll('.total-price-display');
      
      totalPriceDisplays.forEach(display => {
        const basePrice = parseInt(display.dataset.basePrice);
        
        // Find the closest quantity selector
        const closestForm = display.closest('form');
        const quantityInput = closestForm ? closestForm.querySelector('quantity-selector-component input[type="number"]') : null;
        
        if (!quantityInput) return;
        
        const currentQuantity = quantity !== null ? quantity : parseInt(quantityInput.value) || 1;
        const totalPrice = basePrice * currentQuantity;
        
        // Format the price using Shopify's money format
        const formattedPrice = this.formatMoney(totalPrice);
        display.textContent = formattedPrice;
      });
    }

    formatMoney(cents) {
      // Basic money formatting - you may need to adjust based on your shop's currency settings
      const dollars = (cents / 100).toFixed(2);
      return `$${dollars}`;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new AddToCartTotalPrice());
  } else {
    new AddToCartTotalPrice();
  }
  } catch(e) { console.error(e); }
})();

})();
